import * as React from 'react';

import { TagActionContext, TagValueContext } from './context';
import { useTagAction, useTagValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const TagFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <TagValueContext.Provider value={state}>
      <TagActionContext.Provider value={dispatch}>
        {children}
      </TagActionContext.Provider>
    </TagValueContext.Provider>
  );
};

export { TagFormContext, useTagAction, useTagValue };
